import axios from 'axios';

// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'params' implicitly has an 'any' type.
export const textToSpeech = params => {
  const { teamId, text } = params;
  return axios.post('/api/speech/preview', { text, team_id: teamId });
};
